export default __webpack_public_path__ + "media/components/PackageEditor/images/preview-automatic_slots-ae86be5208beaa25d92fef9b4377d4f6.png";